import { DataCache, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { ManagePilotLookups } from 'data/models/ManagePilotLookups';

export class ManagePilotLookupsCache extends DataCache {
    // TH 01/18/2017 -- Feeling Gollum-ish...
    ManagePilotLookupses = PCCollection(ManagePilotLookups);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship   (this.ManagePilotLookupses, data.PilotAgencies, l => l.PilotAgency, null);
        new QueryResultsRelationship(this.ManagePilotLookupses, data.Organizations, l => l.Organizations);
        new QueryResultsRelationship(this.ManagePilotLookupses, data.Pilots,        l => l.Pilots);
    }
}


// WEBPACK FOOTER //
// ./apps/pilots/managepilotlookups/cache.ts